<template>
  <td class="UpdatedDatetime">
    {{ date }}
  </td>
</template>

<script>
import { dateTimeFormatString } from '@/utils/dateUtil'
export default {
  name: 'date',
  props: {
    opt: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      date: '',
    }
  },
  watch: {
    opt: {
      handler(data) {
        const dateCurrent = data.item._MetaData.UpdatedDatetime || data.item._MetaData.CreatedDatetime
        this.date = dateTimeFormatString(dateCurrent)
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped></style>
